var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg3450",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160.95 162.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-222{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3478"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3480",
    className: "cls-222",
    d: "M64,20.9s-25.7.3-25.4,23.4,5,43.4,12.7,54.8,27.4,41.1,49.8,38.1c0,0,11-2.3,19.4-7.7l-27.1-21.1s-8,5-13-1.7-20.7-37.8-20.7-37.8-4.3-10,5.3-14.4L64,20.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3482",
    className: "cls-222",
    d: "M67,20.9s2-.7,5.7,1.3,3.7,3.7,3.7,3.7l.3,23.1s-1,1.3-2.3,2.7-5.7,3.3-6.3,2c-.8-1.4-1.1-32.8-1.1-32.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3484",
    className: "cls-222",
    d: "M95.61,106l7.4-3.9s1.7-.3,4.3,1.3S124,116.1,124,116.1s2.3,2,1.7,4.3-2.3,7.4-2.3,7.4L95.61,106Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e243b355.svg";
export { ForwardRef as ReactComponent };